import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import { Space } from "../../../space/Space";
import React, { useState } from "react";
import { IssuesModal } from "./IssuesModal";
import { KeyIssuesProps } from "./types";

export const KeyIssues: React.FC<KeyIssuesProps> = ({ data }) => {
    const [openEditIssuesModal, setOpenEditIssuesModal] = useState(false);

    const keyIssues =
        data?.appealDetails?.appealApproachCalculationData?.exportAppealsPackage?.keyIssues || [];

    const onClose = () => setOpenEditIssuesModal(false);

    return (
        <>
            <Box type="outline" spacingInset="400">
                <Row alignmentHorizontal="justify" spacingInset="200">
                    <Text type="h300">Key Issues</Text>
                    <Button
                        type="tertiary"
                        size="small"
                        onClick={() => setOpenEditIssuesModal(true)}
                    >
                        Edit
                    </Button>
                </Row>
                <Space size="s" />
                <Column>
                    {keyIssues.map((text: string, index: number) => (
                        <Text key={index}>{`${index + 1}) ${text}`}</Text>
                    ))}
                </Column>
            </Box>

            <IssuesModal
                open={openEditIssuesModal}
                onClose={onClose}
                initialData={keyIssues}
                immutableInitialData={data}
            />
        </>
    );
};
